import styled from 'styled-components';

const RecentReportTitleBar = styled.div`
  background-color: ${(props): string => props.theme.colors.paleBlue};
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${props.theme.spaces.xl}`};
  display: grid;
  grid-template-columns: auto auto;

  span {
    padding-top: 6px;
  }
`;

export { RecentReportTitleBar };
